import { cn } from '../utilitarios/cn'

const TAMANHOS = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-9 w-9 border-[3px]',
} as const

export interface PropriedadesGirador {
  tamanho?: keyof typeof TAMANHOS
  className?: string
  /** Texto para leitor de tela. `null` quando há rótulo visível ao lado. */
  rotulo?: string | null
}

/** Indicador de carregamento. `role="status"` para o leitor de tela anunciar. */
export function Girador({ tamanho = 'md', className, rotulo = 'Carregando' }: PropriedadesGirador) {
  return (
    <span
      role="status"
      className={cn(
        'inline-block animate-spin rounded-full border-current border-r-transparent align-[-0.125em]',
        TAMANHOS[tamanho],
        className,
      )}
    >
      {rotulo ? <span className="sr-only">{rotulo}</span> : null}
    </span>
  )
}
